import styled, { css } from 'styled-components'
import { maxDesktopWidth, breakpoints, colors } from 'constant'

const { md } = breakpoints

export const MainWrapper = styled.div`
  margin-top: 12px;
`

export const HeroPlaceholder = styled.div`
  background-color: transparent;
  border: 2px solid ${colors.c9};
  width: 792px;
  height: 301px;
  border-radius: 16px;
`

export const UploadedHero = styled.div`
  margin-top: 24px;
  width: 160px;
  height: 86px;
  border-radius: 16px;
  background-image: url(${({ $imageUrl }) => $imageUrl});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: flex-end;
  padding: 5px;

  > button {
    width: 23px;
    height: 23px;
    padding: unset;

    > svg {
      height: 10px;
      margin: unset;
    }
  }
`

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  transform: translateY(112px);
`

export const UploadButton = styled.button`
  display: flex;
  align-items: center;
  color: white;
  background: ${colors.c18};
  border: none;
  height: 50px;
  justify-content: center;
  border-radius: 100px;
  font-size: 14px;
  cursor: pointer;
  width: 160px;
  align-self: flex-end;

  > svg {
    margin-right: 8px;
    height: 18px;
    width: 18px;
  }
`
